import { useSignupContext } from './useSignupContext'

export const useDispatch = () => useSignupContext().dispatch
